import { render } from "./UserFaces.vue?vue&type=template&id=a429b660&ts=true"
import script from "./UserFaces.vue?vue&type=script&lang=ts"
export * from "./UserFaces.vue?vue&type=script&lang=ts"

import "./UserFaces.vue?vue&type=style&index=0&id=a429b660&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__